module.exports = "/images/mv.svg?98a6a08206ff4248f91b273ce4f26d4d";